/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ReportType {
	UserDefinedReport = 1,
	CustomReport = 2,
	UserDefinedLinkedXyiconReport = 3,
}
